import React from 'react'
import { InAppVideoPlayer } from '../../../lib/components/InAppVideoPlayer'
import { CMSOpportunityDetailsOpportunityVideosType } from '../../../lib/types'

const getRenderableVideos = (videos?: string[]) =>
  (videos ?? []).map((url) => url?.trim()).filter((url): url is string => Boolean(url))

const CMSOpportunityVideos = ({
  opportunityVideos,
}: {
  opportunityVideos?: CMSOpportunityDetailsOpportunityVideosType
}) => {
  const videos = getRenderableVideos(opportunityVideos?.videos)

  if (!videos.length) {
    return null
  }

  return (
    <div className='opportunity-cms-videos' data-testid='cms-opportunity-videos-content'>
      {videos.map((videoUrl, index) => (
        <InAppVideoPlayer
          key={`${videoUrl}-${index}`}
          videoUrl={videoUrl}
          ariaLabel={`Play opportunity video ${index + 1}`}
          testId={`cms-opportunity-video-${index}`}
        />
      ))}
    </div>
  )
}

export { CMSOpportunityVideos, getRenderableVideos }
